import { required, helpers } from '@vuelidate/validators'

export function rulesMessages()  {
    return {
        required: helpers.withMessage('Campo obrigatório', required) 
    }
}